// extracted by css-extract-rspack-plugin
export default {"card":"znaii","table":"ReoTg","row":"amR2M","action":"Vb8_C","rowEditor":"ijj2D","input":"WpNHu","inputError":"vkhLE"};